import {ConversationMessage, ConversationMessageTriggerType} from "@/conversation/interfaces";

/**
 * The labels of the trigger types, shared by the history filter and the message title
 * so a row cannot be filtered as one type and labelled as another.
 */
export const TRIGGER_TYPE_LABELS: Record<ConversationMessageTriggerType, string> = {
    batch: "Campagne",
    sequence: "Séquence automatique",
    "renewal-date": "Rappel renouvellement",
    manual: "Envoi manuel",
};

/**
 * The trigger type options of the history filter, in display order.
 */
export const TRIGGER_TYPE_OPTIONS: {value: ConversationMessageTriggerType, label: string}[] = [
    {value: "batch", label: TRIGGER_TYPE_LABELS.batch},
    {value: "sequence", label: TRIGGER_TYPE_LABELS.sequence},
    {value: "renewal-date", label: TRIGGER_TYPE_LABELS["renewal-date"]},
    {value: "manual", label: TRIGGER_TYPE_LABELS.manual},
];

/**
 * Resolve the trigger type of a message.
 *
 * A batch wins over the triggerable: some messages carry both, and the campaign is
 * the meaningful trigger. Messages triggered by an RCS flow resolve to `manual`, as
 * only the first message of a flow reaches the history.
 */
export const triggerTypeOf = (message: ConversationMessage): ConversationMessageTriggerType => {
    if (message.batch_id) {
        return "batch";
    }

    switch (message.triggerable_type) {
        case "notification-sequence-message-instance":
            return "sequence";
        case "renewal-date":
            return "renewal-date";
        default:
            return "manual";
    }
};
